﻿import { inject } from "inversify";
import * as ILicenseRepository from "@domain/repositories/ILicenseRepository";
import type { SupportedSoftware } from "@domain/repositories/ISoftwareVersionsRepository";
import { TYPES } from "@utils/inversifyJS/types";

export class SaveLicenseService {
  constructor(
    @inject(TYPES.ILicenseRepository)
    private readonly licenseRepository: ILicenseRepository.ILicenseRepository,
  ) {}

  public async execute(licenseKey: string, software: SupportedSoftware = "Spectronaut"): Promise<void> {
    await this.licenseRepository.saveLicense(licenseKey, software);
  }

  /**
  Which search engines currently have a license in the cluster.
  */
  public async getStatus(): Promise<ILicenseRepository.LicenseStatus> {
    return this.licenseRepository.getStatus();
  }
}
